// @core/api/endpoints/fiscalization/list_fiscal_points.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListFiscalPointsResponse,
} from '../../../types/fiscalization';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/fiscalization';

/**
 * List fiscal points
 * Returns a paginated list of fiscal points with optional filtering by provider, status, or country.
 */
export async function ListFiscalPoints(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListFiscalPointsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/fiscal-points`;
  const requestOptions = options;
  return client.get<ListFiscalPointsResponse>(requestPath, { ...requestOptions, params });
}
